var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHomeWork = function SvgHomeWork(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D96FF",
    d: "M1.125 9.134q0-.332.15-.625.152-.294.423-.478l3.519-2.508a1.3 1.3 0 0 1 .782-.253q.204 0 .4.06.197.058.384.193l3.52 2.508q.27.184.421.478t.151.625v4.885q0 .56-.398.958a1.3 1.3 0 0 1-.958.398H8.8q-.56 0-.958-.398a1.3 1.3 0 0 1-.399-.958v-1.89a.88.88 0 0 0-.265-.643.88.88 0 0 0-.643-.265H5.466a.88.88 0 0 0-.643.265.88.88 0 0 0-.265.644v1.89q0 .558-.398.957a1.3 1.3 0 0 1-.958.398H2.48q-.56 0-.958-.398a1.3 1.3 0 0 1-.398-.958zm15.75-5.153v10.038q0 .56-.398.958a1.3 1.3 0 0 1-.958.398h-2.48a.64.64 0 0 1-.47-.194.64.64 0 0 1-.194-.47V8.384q0-.332-.145-.625a1.24 1.24 0 0 0-.415-.48l-3.53-2.53a1.5 1.5 0 0 1-.39-.417.97.97 0 0 1-.147-.521v-.13a1 1 0 0 1 .31-.762q.312-.294.804-.294h6.657q.56 0 .958.398.398.399.398.958m-3.7 2.682h.65q.135 0 .237-.101a.33.33 0 0 0 .101-.237v-.65q0-.135-.101-.237a.33.33 0 0 0-.237-.101h-.65q-.135 0-.237.101a.33.33 0 0 0-.101.237v.65q0 .135.101.237a.33.33 0 0 0 .237.101m0 3h.65q.135 0 .237-.101a.33.33 0 0 0 .101-.237v-.65q0-.135-.101-.237a.33.33 0 0 0-.237-.101h-.65q-.135 0-.237.101a.33.33 0 0 0-.101.237v.65q0 .135.101.237a.33.33 0 0 0 .237.101m0 3h.65q.135 0 .237-.101a.33.33 0 0 0 .101-.237v-.65q0-.135-.101-.237a.33.33 0 0 0-.237-.101h-.65q-.135 0-.237.101a.33.33 0 0 0-.101.237v.65q0 .135.101.237a.33.33 0 0 0 .237.101"
  }))));
};
export default SvgHomeWork;